export const HEADERS_AND_PARAMS = {
    ACCOUNT_IDENTIFIER: 'accountIdentifier',
    AUTHORIZATION: 'authorization',
    CODE: 'code',
    PROGRAM_CODE: 'programcode',
    REQUEST_ID: 'x-gd-requestid',
    ACCESS_TOKEN: 'ACCESS_TOKEN',
    SIGN: 'sign',
    SUBSCRIPTION_KEY: 'Ocp-Apim-Subscription-Key',
};

export const SET_PIN = {
    PIN: 'atmPin',
    PAYMENT_INSTRUMENT_IDENTIFIER: 'PaymentInstrumentIdentifier',
};

export const ACTIVATE_CARD = {
    CARD_NUMBER: 'cardNumber',
    EXPIRATION_DATE: 'expDate',
    CVV: 'cvv',
    PIN: 'atmPin',
    PAYMENT_INSTRUMENT_IDENTIFIER: 'PaymentInstrumentIdentifier',
    ACTIVATED_STATUS: 'activated',
    NOT_ACTIVATED_STATUS: 'notactivated',
};

export const STATUS_CODE = {
    UNAUTHORIZED: 401,
    NOT_FOUND: 404,
    PRE_CHECK_FAILED: 412,
    INTERNAL_ERROR: 502,
};

export const VALIDATE_CARD = {
    CARD_NUMBER: 'cardNumber',
    EXPIRATION_DATE: 'expDate',
    CVV: 'cvv',
    IS_EXPIRATION_DATE_OPTIONAL: 'isExpirationDateOptional',
    PAYMENT_INSTRUMENT_IDENTIFIER: 'PaymentInstrumentIdentifier',
};

export const SUBSCRIPTION_KEYS = {
    DEV: '969fcd30a23c42ec98e62d7a86229399',
    QA: '9279ad33b00c44b28f88224de1fe4fe9',
    PIE: 'c47c5ba00e3c43ef9011567161a10f4b',
    PRF: 'd5cf4275ae2c448a8b2ea865f030611a',
    PROD: '5d9b1262b1ed4b78a31ac1108c68a804',
};

export const CARD_TYPE = {
    VIRTUAL: 'virtual',
};

export const VALIDATE_CARD_STATUS_CODE = {
    INVALID_INFO_STATUS_CODE: '4',
    INVALID_INFO_SUB_STATUS_CODE: '302',
};

export default {};
